import React, { forwardRef, useContext } from 'react';
import { ToolbarContext } from '../components/toolbar-context.js';
import { ColorIndicator } from './color-indicator.js';
import styles from './buttons.less.js';

const ActualButton = forwardRef((props, ref) => {
    const { name, ariaAttributes, icon, text, arrow, color, clickable, style, onClick, onDoubleClick, onMouseDown, } = props;
    const toolbarContext = useContext(ToolbarContext);
    const classes = [styles.actual];
    const couldVerticallyArrange = toolbarContext.multirows && (icon && text);
    if (couldVerticallyArrange) {
        classes.push(styles.vertical);
    }
    const isSplitButtonGroup = arrow && clickable;
    return (React.createElement("div", Object.assign({ id: `toolbar-button-${name}`, key: `toolbar-button-${name}` }, ariaAttributes, { role: isSplitButtonGroup ? 'group' : 'button', className: classes.join(' '), style: style, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, ref: ref }),
        React.createElement("div", { className: styles['icon-container'], "aria-hidden": !isSplitButtonGroup },
            React.createElement("div", { className: styles.icon, role: "button", "aria-label": ariaAttributes === null || ariaAttributes === void 0 ? void 0 : ariaAttributes['aria-label'] },
                icon,
                React.createElement(ColorIndicator, { color: color, className: styles['color-indicator'] })),
            React.createElement("div", { className: styles.text }, text),
            React.createElement("div", { className: styles.arrow }, arrow)),
        React.createElement("div", { className: styles.text, "aria-hidden": true }, text)));
});

export { ActualButton };
//# sourceMappingURL=actual-button.js.map
